module.exports = __webpack_public_path__ + "img/teamWork.87d5b2cb.jpg";